import React from 'react'
import styled from 'styled-components'

import COLORS from 'pared/constants/colors'

import { useVariables } from '../variables'

export interface IPropsType {
  type: 'link'
  label: string
  href: string
  target?: string
  hide?: `<%- ${string} %>`
  margin?: string
  width?: string
  color?: string
  backgroundColor?: string
  padding?: string
  borderRadius?: string
}

const StyledLink = styled.a<
  Pick<
    IPropsType,
    | 'width'
    | 'margin'
    | 'color'
    | 'backgroundColor'
    | 'padding'
    | 'borderRadius'
  >
>`
  display: inline-block;
  ${({ margin }) => (!margin ? '' : `margin: ${margin};`)}
  ${({ width }) => (!width ? '' : `width: ${width};`)}
  ${({ padding }) => (!padding ? '' : `padding: ${padding};`)}
  ${({ backgroundColor }) =>
    !backgroundColor ? '' : `background-color: ${backgroundColor};`}
  ${({ borderRadius }) =>
    !borderRadius ? '' : `border-radius: ${borderRadius};`}
  color: ${({ color }) => color || COLORS.Expo};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 50%;
  }
`

const Link = ({
  label,
  href,
  target = '_blank',
  hide,
  color,
  backgroundColor,
  ...props
}: IPropsType) => {
  const { template } = useVariables()

  if (hide && template(hide) !== 'false') return null

  return (
    <StyledLink
      {...props}
      href={template(href)}
      target={target}
      // why: external target needs noopener/noreferrer to prevent the opened
      // page from accessing window.opener (reverse-tabnabbing / perf leak)
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      color={color && template(color, { external: { colors: COLORS } })}
      backgroundColor={
        backgroundColor &&
        template(backgroundColor, { external: { colors: COLORS } })
      }
    >
      {label}
    </StyledLink>
  )
}

export default React.memo(Link) as unknown as typeof Link
